export const JPEG_DATA_PREFIX = 'data:image/jpeg;base64,'
export const JPEG_START_OF_IMAGE_BYTES = [0xFF, 0xD8]
export const BYTES_IN_MB = 1048576
